
  import { defineComponent, PropType } from 'vue';

  import Tooltip from '@/common/ui/Tooltip.vue';

  import type { TTableAggregatedProgressBarOptions } from './types/tableTypes';

  import { TPageMetadata } from '@/types/meta';

  export default defineComponent({
    name: 'TableAggregatedProgress',
    components: { Tooltip },
    props: {
      meta: {
        type: Object as PropType<TPageMetadata>,
        required: true,
      },
      options: {
        type: Object as PropType<TTableAggregatedProgressBarOptions>,
        default: () => ({}),
      },
      isLoading: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      getShowHeader(): boolean {
        return Boolean(this.options.title || this.options.hintText);
      },
      getItemsTotal(): number {
        return this.meta.itemsTotal ?? 0;
      },
      getLoadedItems(): number {
        if (!this.getItemsTotal || this.isLoading) {
          return 0;
        }

        const pageNumber = this.meta.pageNumber ?? 1;
        const pageSize = this.meta.pageSize ?? 0;

        // бэк возвращает все записи, если pageSize === 0 (пока такая настройка только для фтс (месяц))
        if (pageSize === 0) {
          return this.getItemsTotal;
        }

        const paginatedLoaded = pageNumber * pageSize;

        return Math.min(paginatedLoaded, this.getItemsTotal);
      },
      getProgressRatio(): number {
        if (!this.getItemsTotal || this.isLoading) {
          return 0;
        }
        return Math.min(1, this.getLoadedItems / this.getItemsTotal);
      },
      getProgressPercent(): number {
        return Math.round(this.getProgressRatio * 100);
      },
      getProgressAriaText(): string {
        return `Загружено ${this.getProgressPercent}%`;
      },
      getShowProgress(): boolean {
        return this.getItemsTotal > 0;
      },
    },
  });
